<div class="modal-header">
	<h4 class="modal-title">Create Task</h4>
	<button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
	<form
		#templateForm="ngForm"
		id="taskModalForm"
		[formGroup]="componentForm"
		(ngSubmit)="save()">

		@if (componentForm.invalid && templateForm.submitted) {
			<gandalf-lib-validation-messages
				[form]="componentForm"
				[requestObj]="request">
			</gandalf-lib-validation-messages>
		}

		@if (isLoading) {
			<div class="text-center p-3">
				<i class="fa fa-spinner fa-spin fa-2x"></i>
			</div>
		} @else {
			<pms-task-form-fields
				[form]="componentForm"
				[categories]="categories"
				[disableCategorySelect]="data?.disableCategorySelect"
				[disablePatientSelect]="data?.disablePatientSelect"
				[hideNavigateToPatient]="true">
			</pms-task-form-fields>
		}
	</form>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" (click)="close()" data-test-id="taskModalCancelButton">
		<i class="fa fa-close"></i> Cancel
	</button>
	<button
		form="taskModalForm"
		type="submit"
		class="btn btn-success"
		[disabled]="disableSave"
		data-test-id="taskModalSaveButton">
		@if (disableSave) {
			<i class="fa fa-spinner fa-spin"></i>
		}
		<i class="fa fa-save"></i> Save
	</button>
</div>
